import BaseService from '_services/rest/base';

class ReportService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/report`;
  }

  exportReportProductCsv(pagination) {
    return this.request(`${this.getUrl()}/product/export`, pagination.filters)
      .catch(err => {
        throw err;
      });
  }

  exportReportQuotationCsv(pagination) {
    return this.request(`${this.getUrl()}/quotation/export`, pagination.filters)
      .catch(err => {
        throw err;
      });
  }

  exportReportSellerCsv(pagination) {
    return this.request(`${this.getUrl()}/seller/export`, pagination.filters)
      .catch(err => {
        throw err;
      });
  }

  getReportFilters() {
    return this.request(`${this.getUrl()}/filters`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getReportDrivesList(filters) {
    return this.request(`${this.getUrl()}/drive`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getReportProductList(pagination) {
    return this.request(`${this.getUrl()}/product/${pagination.skip}/${pagination.take}`, pagination.filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getReportQuotationList(pagination) {
    return this.request(`${this.getUrl()}/quotation/${pagination.skip}/${pagination.take}`, pagination.filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getReportSellerList(pagination) {
    return this.request(`${this.getUrl()}/seller/${pagination.skip}/${pagination.take}`, pagination.filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }
}

export default new ReportService();
